import axios from 'axios';

export const fetchCohortAttributes = async () => {
    try {
        const url = constructCSMCohortUrl();
        const apiOutput = await axios.get(url, {
            withCredentials: true
        });
        const attributes = apiOutput?.data?.attributes || {};
        const filteredAttributes = Object.fromEntries(
            Object.entries(attributes).filter(([, value]) => value !== null)
        );
        return filteredAttributes || {};
    } catch {
        return {};
    }
};

const constructCSMCohortUrl = () =>
    window.SAC_BASE_URL +
    '/gateway/api/customer-context/customer/cohort/csm-experiment';

export const fetchCustomerOverview = async (isAtlassianAccount) => {
    try {
        const url = constructCustomerOverviewUrl();
        const apiOutput = await axios.get(url, {
            withCredentials: true
        });
        const entitlements = apiOutput?.data?.entitlements || [];
        return transformEntitlements(entitlements, isAtlassianAccount);
    } catch {
        return [];
    }
};

const transformEntitlements = (entitlements, isAtlassianAccount) => {
    const groups = {};
    entitlements.forEach((ent) => {
        const url = ent.cloudUrl;
        if (!url) return;
        if (!groups[url]) groups[url] = [];
        const p = ent.product;
        groups[url].push({
            name: p.name,
            platform: p.platform,
            edition: p.edition,
            supportLevel: p.supportLevel,
            type: p.type ?? ent.type,
            licenseType: p.licenseType ?? ent.licenseType,
            customerRoles: p.customerRoles
        });
        (p.children || []).forEach((child) => {
            groups[url].push({
                name: child.name,
                platform: child.platform,
                edition: child.edition,
                supportLevel: child.supportLevel,
                type: child.type ?? ent.type,
                licenseType: child.licenseType ?? ent.licenseType,
                customerRoles: child.customerRoles
            });
        });
    });
    return Object.entries(groups).map(([cloudUrl, product]) => ({
        cloudUrl,
        isAtlassianAccount,
        product
    }));
};

const constructCustomerOverviewUrl = () =>
    window.SAC_BASE_URL + '/gateway/api/customer-context/customer/overview';
